import { GMetrixTableColumnToggle, GMetrixTableDateFilter, GMetrixTableFilters } from 'components/GMetrixTable/components/toolbar/components';
import { KendoPostSearch } from 'components/KendoPostSearch/KendoPostSearch';
import { useGMetrixTable } from 'components/GMetrixTable/context';
import { Col, Row } from 'react-bootstrap';

import 'components/GMetrixTable/components/toolbar/styles/GMetrixTableToolbar.scss';

export const GMetrixTableToolbar = () => {

    const { dateFilter, extraToolBarButtons, filters, inlineColumnToggle, preSearch, preSearchData, searchAutoFocus,
        searchPlaceholder, searchTerm, setSearchTerm, toggleColumns } = useGMetrixTable();

    const md = dateFilter ? 6 : 'auto';

    return (

        <Row className="gmetrix-table-toolbar d-flex flex-wrap align-items-center g-2 overflow-visible">

            {!!setSearchTerm && (
                <Col lg={4} md={6} xs={12}>
                    <KendoPostSearch
                        autoFocus={searchAutoFocus}
                        isPostFiltering={preSearch}
                        placeholder={searchPlaceholder}
                        preSearchOnClick={preSearchData}
                        searchTerm={searchTerm ?? ''}
                        setSearchTerm={setSearchTerm}
                    />
                </Col>
            )}

            {!!filters?.length && (
                <Col className={'gx-md-2'} lg={'auto'} md={md} xs={12}>
                    <GMetrixTableFilters />
                </Col>
            )}

            {!!dateFilter && (
                <Col className={'gx-md-2'} lg={'auto'} md={md} xs={12}>
                    <GMetrixTableDateFilter />
                </Col>
            )}

            {toggleColumns && (
                <Col className={`column-toggle-wrapper d-flex ${inlineColumnToggle ? '' : 'ms-auto'}`} lg={'auto'} md={md} xs={12}>
                    <GMetrixTableColumnToggle/>
                </Col>
            )}

            {!!extraToolBarButtons && (
                <Col className={'d-flex ms-auto'} lg={'auto'} md={md} xs={12}>
                    {extraToolBarButtons}
                </Col>
            )}

        </Row>

    );

};